import { render, staticRenderFns } from "./EventFormCard.vue?vue&type=template&id=60a12cde&scoped=true&"
import script from "./EventFormCard.vue?vue&type=script&lang=js&"
export * from "./EventFormCard.vue?vue&type=script&lang=js&"
import style0 from "./EventFormCard.vue?vue&type=style&index=0&id=60a12cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a12cde",
  null
  
)

export default component.exports